import React from 'react';
import { AdminFinanceDownloadProps } from './types';
import Papa from 'papaparse';
import { flattenJSONForCSV } from '../../utils';

const AdminFinanceDownload = ({ json, name }: AdminFinanceDownloadProps) => {
	const csvData = Papa.unparse(json.map(flattenJSONForCSV));

	// Create a Blob object and a download URL
	const blob = new Blob([csvData], { type: 'text/csv' });
	const url = URL.createObjectURL(blob);

	return (
		<a href={url} download={name}>
			<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M12.75 25.25C12.9489 25.25 13.1397 25.329 13.2803 25.4697C13.421 25.6103 13.5 25.8011 13.5 26V28.25C13.5 28.388 13.612 28.5 13.75 28.5H26.25C26.3163 28.5 26.3799 28.4737 26.4268 28.4268C26.4737 28.3799 26.5 28.3163 26.5 28.25V26C26.5 25.8011 26.579 25.6103 26.7197 25.4697C26.8603 25.329 27.0511 25.25 27.25 25.25C27.4489 25.25 27.6397 25.329 27.7803 25.4697C27.921 25.6103 28 25.8011 28 26V28.25C28 28.7141 27.8156 29.1592 27.4874 29.4874C27.1592 29.8156 26.7141 30 26.25 30H13.75C13.2859 30 12.8408 29.8156 12.5126 29.4874C12.1844 29.1592 12 28.7141 12 28.25V26C12 25.8011 12.079 25.6103 12.2197 25.4697C12.3603 25.329 12.5511 25.25 12.75 25.25Z'
					fill='white'
				/>
				<path
					d='M13.2198 17.97C13.2893 17.9003 13.3719 17.8451 13.4629 17.8074C13.5538 17.7697 13.6513 17.7502 13.7498 17.7502C13.8482 17.7502 13.9457 17.7697 14.0366 17.8074C14.1276 17.8451 14.2102 17.9003 14.2798 17.97L19.2498 22.939V10.75C19.2498 10.5511 19.3288 10.3603 19.4694 10.2197C19.6101 10.079 19.8008 10 19.9998 10C20.1987 10 20.3894 10.079 20.5301 10.2197C20.6707 10.3603 20.7498 10.5511 20.7498 10.75V22.939L25.7198 17.97C25.8603 17.8294 26.051 17.7505 26.2498 17.7505C26.4485 17.7505 26.6392 17.8294 26.7798 17.97C26.9203 18.1106 26.9993 18.3012 26.9993 18.5C26.9993 18.6988 26.9203 18.8894 26.7798 19.03L20.5298 25.28C20.4602 25.3497 20.3776 25.4049 20.2866 25.4426C20.1957 25.4803 20.0982 25.4998 19.9998 25.4998C19.9013 25.4998 19.8038 25.4803 19.7129 25.4426C19.6219 25.4049 19.5393 25.3497 19.4698 25.28L13.2198 19.03C13.1501 18.9604 13.0948 18.8778 13.0571 18.7869C13.0194 18.6959 13 18.5984 13 18.5C13 18.4016 13.0194 18.3041 13.0571 18.2131C13.0948 18.1222 13.1501 18.0396 13.2198 17.97Z'
					fill='white'
				/>
			</svg>
		</a>
	);
};

export default AdminFinanceDownload;
